export default class {
  _NL = '\r\n'
  /**
   * Permite convertir un certificado X509 publico en base64 a formato PEM.
   * @param {*} cer
   */
  x509ToPem(cer) {
    if (this._hasPemFormat(cer)) {
      return cer
    }

    return `-----BEGIN CERTIFICATE-----${this._NL}${this._formatPem(cer)}${
      this._NL
    }-----END CERTIFICATE-----`
  }

  /**
   * Permite convertir un archivo de base64 tipo key (PKCS#8) llave privada a formato PEM.
   * @param {*} der Archivo del tipo key llave privada en base64
   */
  pkcs8ToPem(der) {
    if (this._hasPemFormat(der)) {
      return der
    }

    return `-----BEGIN ENCRYPTED PRIVATE KEY-----${this._NL}${this._formatPem(
      der
    )}${this._NL}-----END ENCRYPTED PRIVATE KEY-----${this._NL}`
  }

  _hasPemFormat(base64String) {
    return (
      base64String.indexOf('-----BEGIN CERTIFICATE-----') === 0 ||
      base64String.indexOf('-----BEGIN ENCRYPTED PRIVATE KEY-----') === 0
    )
  }

  _formatPem(base64String) {
    const total = base64String.length
    let formatted = ''

    for (let index = 0, count = 0; index < total; index++, count++) {
      if (count > 63) {
        formatted = formatted + this._NL
        count = 0
      }

      formatted = formatted + base64String[index]
    }

    return formatted
  }
}
